const REQUIRED_WARNING =
  "Required by the marketplace — do not ignore; publishing will fail without it.";
const CONDITIONAL_WARNING =
  "Conditionally required — required only when related fields take certain values; check before ignoring.";

export const isRequiredLevel = (level: unknown) =>
  Boolean(requiredWarning(level)?.required);

export function requiredWarning(
  level: unknown,
): { required: boolean; message: string } | null {
  const normalized = typeof level === "string" ? level.toUpperCase() : null;
  if (normalized === "REQUIRED")
    return { required: true, message: REQUIRED_WARNING };
  if (normalized === "CONDITIONALLY_REQUIRED")
    return { required: false, message: CONDITIONAL_WARNING };
  return null;
}
